import { StoreBaseHandler } from "../../../../infrastructure/base-handlers";
import { setUpFilterValues } from "./actions";
import { SetUpFiltersCommand } from "./request";

export class SetUpFiltersHandler extends StoreBaseHandler {
  async handle(request: SetUpFiltersCommand) {
    try {
      this.store.dispatch(setUpFilterValues(request.payload));
    } catch (e) {
      console.error(e.message);
    }
  }
}
